export default __webpack_public_path__ + "tileSoundEffect.wav";